import { get } from 'services/request.service';
import { getEnv } from 'services/apiEnv.service';
import { AuditResponseDocument, CapaDocument, GapAnalysisDocument } from './etq.types';

const BASE_URL = `${getEnv('IT_BASE_URL')}/etq`;

const getDocumentPage = async <T>(url: string, pageNumber: number) => {
  const response = await get({ url, params: { pageNumber } });

  const paginationMetadata = (() => {
    try {
      return JSON.parse(response.headers?.paginationmetadata);
    } catch {
      return undefined;
    }
  })();

  return {
    items: (response.data ?? []) as T[],
    paginationMetadata
  };
};

export const getCAPADocuments = async (pageNumber = 1) => {
  return getDocumentPage<CapaDocument>(`${BASE_URL}/capa`, pageNumber);
};

export const getGAPAnalysisDocuments = async (pageNumber = 1) => {
  return getDocumentPage<GapAnalysisDocument>(`${BASE_URL}/gap-analysis`, pageNumber);
};

export const getAuditResponseDocuments = async (pageNumber = 1) => {
  return getDocumentPage<AuditResponseDocument>(`${BASE_URL}/audit-response`, pageNumber);
};

export const getCapaDocumentById = async ({ id }: { id: number }): Promise<CapaDocument> => {
  return (await get({ url: `${BASE_URL}/capa/${id}` })).data;
};

export const getGAPAnalysisDocumentById = async ({
  id
}: {
  id: number;
}): Promise<GapAnalysisDocument> => {
  return (await get({ url: `${BASE_URL}/gap-analysis/${id}` })).data;
};

export const getAuditResponseDocumentById = async ({
  id
}: {
  id: number;
}): Promise<AuditResponseDocument> => {
  return (await get({ url: `${BASE_URL}/audit-response/${id}` })).data;
};
